import baseContextComponent from "@/components/baseContextComponent";
import { tableItem } from "@/models/tableItem";
import api from "@/services/api";
import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import { connectionStringData } from "../../models/connectionStringData";
import { mapGetters } from "vuex";

@Component({
	computed: { ...mapGetters(["getConnectionSelected"]) }
})
export default class settingsTableListPage extends baseContextComponent {
	tables: tableItem[] = [];
	connections: connectionStringData[] = [];
	connection: string = "";

	getConnectionSelected: string;

	search: string = null;

	get tableName(): string {
		return this.$route && this.$route.params && this.$route.params.name ? this.$route.params.name : null;
	}
	get tableList(): tableItem[] {
		var self = this;
		if (self.tables == null) return [];
		if (self.search == null) return self.tables;
		var filtered = self.tables.filter(x => (x.friendlyName || "").indexOf(self.search) != -1);
		return filtered;
	}
	get table(): tableItem {
		var self = this;
		var item = self.tables.find(x => x.name == self.tableName);
		return item || new tableItem();
	}
	get showLeftColumn(): boolean {
		var self = this;
		return self.isSmallScreen == false || self.tableName == null || self.tableName == "";
	}
	get showRightColumn(): boolean {
		var self = this;
		return self.isSmallScreen == false || (self.tableName != null && self.tableName != "");
	}
	created() {
		var self = this;
		self.fetch();
	}
	fetch() {
		var self = this;

		api.getConnections().then((res: connectionStringData[]) => {
			self.connections = res;

			if (self.getConnectionSelected) {
				self.connection = self.getConnectionSelected;
			} else {
				var defaultCon = self.connections.find(item => {
					return item.default;
				});

				if (defaultCon) {
					self.connection = defaultCon.name;
				} else {
					self.connection = self.connections[0].name;
				}
			}

			self.getTables();
		});
	}

	onConnectionChange(connection: string) {
		api.changeConnectionSelected(connection);
		this.connection = connection;
		this.$router.push({ name: "settingsTables" }).catch(err => {});

		this.getTables();
	}

	getTables() {
		var self = this;
		self.tables = [];

		api.getTables().then((res: tableItem[]) => {
			self.tables = res;
		});
	}

	isActive(t: tableItem) {
		return t != null && t.name == this.tableName;
	}

	getPath(t: tableItem) {
		var p = t;
		return `/settings-tables/${t.name}`;
	}
}
